<template>
  <div id="the-collection">
    <b-container class="the-collection-container">
      <Header title="The Collection" />
      <div class="cards">
        <ProductCard
          :productCardId="1"
          class="collection-card"
          :productData="{
            title: `“SWEET HOME” LONG-SLEEVE TEE`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/sam/sam-shirt-pride-01.jpg'),
              require('@/assets/images/products/sam/sam-shirt-pride-02.jpg'),
              require('@/assets/images/products/sam/sam-shirt-pride-03.jpg'),
              require('@/assets/images/products/sam/sam-shirt-pride-04.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/sam/sam-shirt-pride-01.jpg'),
              require('@/assets/images/products/sam/sam-shirt-pride-02.jpg'),
              require('@/assets/images/products/sam/sam-shirt-pride-03.jpg'),
              require('@/assets/images/products/sam/sam-shirt-pride-04.jpg'),
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">
            “SWEET HOME”
            <br>
            LONG-SLEEVE TEE
          </h5>
          <div slot="description">
            <p>
              This tee features several figures bursting out of home plate in celebration with home plate lined in
              bright, bold rainbow-colored line work as a way to represent Pride, celebrate the monthlong annual
              festivities and inspire other to always be proud of who they are.
            </p>
            <p>
              Designed in collaboration with Sam Kirk.
              <br>
              Proceeds benefit Center on Halsted.
            </p>
          </div>
        </ProductCard>
        <ProductCard
          :productCardId="2"
          class="collection-card"
          :productData="{
            title: `“TOP FLY” TANK TOP`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/sam/sam-tank-pride-01.jpg'),
              require('@/assets/images/products/sam/sam-tank-pride-02.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/sam/sam-tank-pride-01.jpg'),
              require('@/assets/images/products/sam/sam-tank-pride-02.jpg'),
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">
            "TOP FLY"
            <br>
            TANK TOP
          </h5>
          <div slot="description">
            <p>
              This tank is inspired by the game of baseball and how playing and attending games growing up
              contributed to some of Sam's best childhood memories. It features familiar symbols to the game - bats
              and baseball - with rainbow-colored line work to celebrate Pride and serve as a nod to the artist's
              personal connection to the game.
            </p>
            <p>
              Designed in collaboration with Sam Kirk.
              <br>
              Proceeds benefit Center on Halsted.
            </p>
          </div>
        </ProductCard>
        <ProductCard
          :productCardId="3"
          class="collection-card"
          :productData="{
            title: `“CULTURE CUB” BUCKET HAT`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/sam/sam-bucket-hat-01.jpg'),
              require('@/assets/images/products/sam/sam-bucket-hat-02.jpg'),
              require('@/assets/images/products/sam/sam-bucket-hat-03.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/sam/sam-bucket-hat-01.jpg'),
              require('@/assets/images/products/sam/sam-bucket-hat-02.jpg'),
              require('@/assets/images/products/sam/sam-bucket-hat-03.jpg'),
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">
            “CULTURE CUB”
            <br>
            BUCKET HAT
          </h5>
          <div slot="description">
            <p>
              
            </p>
            <p>
              This stylish bucket hat features the Cubs' "walking bear" logo which was designed with fluid colors
              without rigid lines of separation as a way to show unity.
            </p>
            <p>
              Designed in collaboration with Sam Kirk.
              <br>
              Proceeds benefit Center on Halsted.
            </p>
          </div>
        </ProductCard>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/global/Header";
import ProductCard from "@/components/global/ProductCard";
import moment from "moment";

import { mapState } from "vuex";
export default {
  name: "TheCollection",
  data() {
    return {
      moment,
      productAvailable: false,
    };
  },
  components: {
    Header,
    ProductCard,
  },
  computed: {
    ...mapState(["global"]),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#the-collection {
  padding-bottom: 100px;
  @media (max-width: $lg) {
    padding-bottom: 50px;
  }
  @media (max-width: $md) {
    padding-bottom: 0px;
  }
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-collection-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    @media (max-width: $lg) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .cards {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 50px;
    @media (max-width: $lg) {
      flex-direction: column;
      align-items: center;
    }
  }
  .collection-card {
    width: 318px;
    max-width: 32.2%;
    @media (max-width: $lg) {
      margin-bottom: 50px;
      max-width: 100%;
    }
  }

  p,
  span {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: start;
    line-height: 23px;
    @media (max-width: $lg) {
      text-align: center;
    }
  }
}
</style>
